import React, { useState } from "react";
import PContent from "../../../../../atoms/text/PContent";
import FancyAnimatePoint from "../../../../../atoms/button/FancyAnimatePoint";
import type { MenuItem as MenuItemType } from "../types/navigation";

interface MenuItemProps {
  menuItem: MenuItemType;
  isActive: boolean;
  onMenuClick: (menuItem: MenuItemType) => void;
  onMenuHover: (menuItem: MenuItemType) => void;
  onMenuLeave: () => void;
  menuRef: (el: HTMLAnchorElement | null) => void;
}

const MenuItem: React.FC<MenuItemProps> = ({
  menuItem,
  isActive,
  onMenuClick,
  onMenuHover,
  onMenuLeave,
  menuRef,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const hasSubmenu = menuItem.submenu && menuItem.submenu.length > 0;
  const showDot = hasSubmenu && (isHovered || isActive);

  return (
    <a
      ref={menuRef}
      href={menuItem.href || "#"}
      onClick={(e) => {
        e.preventDefault();
        onMenuClick(menuItem);
      }}
      onMouseEnter={() => {
        setIsHovered(true);
        onMenuHover(menuItem);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        onMenuLeave();
      }}
      className={`relative flex h-full min-w-0 flex-1 cursor-pointer flex-col items-center justify-center rounded-lg px-2 py-2 font-medium transition-all duration-300 laptop:px-4 ${
        isActive
          ? "bg-blue-100 font-bold text-primary"
          : "font-bold text-gray-700 hover:bg-blue-50 hover:text-primary"
      }`}
      data-navbar-element
    >
      <PContent className="text-center font-bold text-dark">
        {menuItem.name}
      </PContent>

      <div className="flex h-3 items-center justify-center transition-all duration-300">
        <div
          className={`transition-all duration-300 ${
            showDot ? "scale-100 opacity-100" : "scale-0 opacity-0"
          }`}
        >
          <FancyAnimatePoint className="mx-auto" size={8} oscillate />
        </div>
      </div>
    </a>
  );
};

export default MenuItem;
